import React, { useEffect, useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

const PreviewHistogram = ({frequencyData}) => {

  const [data, setData] = useState(null);

 useEffect(() => {
    // Transform the data for Recharts
    const result = frequencyData && Object.entries(frequencyData).map(([value, frequency]) => ({
        value: Number(value),
        frequency: Number(frequency)
      })).sort((a, b) => a.value - b.value);

    setData(result);

 },[frequencyData])

  return (
    <div className="text-black">
    <h2 className="text-lg font-semibold mb-4">Profile Completeness Distribution</h2>
    <ResponsiveContainer width="100%" height={450}>
        <BarChart
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 20
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="value"
            label={{
              value: 'Profile Completeness(%)',
              position: 'bottom',
              offset: -10
            }}
          />
          <YAxis
            label={{
              value: 'Profiles',
              angle: -90,
              position: 'insideLeft',
              offset: 0
            }}
          />
          <Tooltip
            formatter={(value, name) => [value, 'Frequency']}
            labelFormatter={(value) => `Value: ${value}`}
          />
          <Bar
            dataKey="frequency"
            fill="#8884d8"
            barSize={60}
            barGap={0}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PreviewHistogram;
